<div class="header-bar">
  <div class="header-left"></div>
  <div class="header-center">Roles & Permissions</div>
  <div *ngIf="newRole" class="header-right">
    <button mat-button color="fiord" (click)="cancel()">Cancel</button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveNewRole()"
      [disabled]="newRoleForm!.invalid"
    >
      Save New Role
    </button>
  </div>
  <div *ngIf="!newRole" class="header-right">
    <button *ngIf="showDelete" mat-button color="warn" (click)="deleteRole()">
      Delete Role
    </button>
    <button
      mat-button
      color="lightGreen"
      (click)="saveRoleUpdates()"
      [disabled]="editRoleForm!.invalid"
    >
      Save Role Updates
    </button>
  </div>
</div>

<div class="role">
  <div *ngIf="newRole" class="container new-role-name-container">
    <lhpe-input
      class="input"
      controlName="roleName"
      placeholder="Enter name of new role"
      [formGroup]="newRoleForm!"
      [required]="true"
    >
    </lhpe-input>
    <lhpe-input
      class="input"
      controlName="roleDesc"
      placeholder="Role Description"
      [formGroup]="newRoleForm!"
      [required]="true"
    >
    </lhpe-input>
  </div>
  <div *ngIf="!newRole" class="container edit-role-name-container">
    <lhpe-select
      class="input select-input"
      controlName="role"
      placeholder="Role"
      [formGroup]="editRoleForm!"
      [required]="true"
      [options]="roleOptions!"
      (change)="onRoleChange($event)"
    >
    </lhpe-select>
    <lhpe-input
      class="input"
      controlName="roleName"
      placeholder="Edit Role name"
      [formGroup]="editRoleForm!"
      [required]="true"
    >
    </lhpe-input>
    <lhpe-input
      class="input"
      controlName="roleDesc"
      placeholder="Role Description"
      [formGroup]="editRoleForm!"
      [required]="true"
    >
    </lhpe-input>
  </div>

  <div class="container permissions-container">
    <div class="container-header no-bottom-border">
      <div class="text">
        Assign permissions for
        {{ newRole ? "New" : editRoleForm!.controls.roleName.value }} Role
      </div>
    </div>
    <div class="container-content">
      <div *ngFor="let group of permissionGroups" class="permission-group">
        <div class="group-heading">
          {{ group.name }}
          <mat-checkbox
            class="checkbox"
            color="lightGreen"
            [(ngModel)]="group.selectAll"
            (change)="onSelectAll(group)"
            >Select All</mat-checkbox
          >
        </div>
        <div class="group-options">
          <div
            *ngFor="let permission of group.permissions"
            class="group-option"
          >
            {{ permission.name }}
            <mat-checkbox
              class="checkbox"
              color="lightGreen"
              [(ngModel)]="permission.selected"
              (change)="onPermissionSelected(permission, group)"
            ></mat-checkbox>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
